import React from 'react';
import PropTypes from 'prop-types';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

const SalesEvolutionChart = ({ data = [] }) => {
  return (
    <div className="statistics-chart">
      <h3 className="statistics-title">Ventas Mensuales</h3>
      <div style={{ width: '100%', height: 300, marginTop: '20px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={data}
           margin={{
            top: 10,
            right: 30,
            left: 0,
            bottom: 20,
          }}
          >
            <defs>
        
              <linearGradient id="colorVentas" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#8b5cf6" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#8b5cf6" stopOpacity={0} />
              </linearGradient>
            </defs>

            <CartesianGrid
              vertical={false}
              strokeDasharray="5 5"
              stroke="#f1f5f9"
            />

            <XAxis
              dataKey="mes_nombre"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: '#94a3b8', fontWeight: 500 }}
              dy={15}
            />

            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: '#94a3b8' }}
            />

            <Tooltip
              content={<CustomTooltip />}
              cursor={{ stroke: '#8b5cf6', strokeWidth: 2, strokeDasharray: '5 5' }}
            />

            <Area
              type="monotone"
              dataKey="cantidad"
              stroke="#8b5cf6"
              strokeWidth={4}
              fillOpacity={1}
              fill="url(#colorVentas)"
              dot={{ r: 4, fill: '#8b5cf6', strokeWidth: 3, stroke: '#fff' }}
              activeDot={{ r: 6, strokeWidth: 0, fill: 'var(--color-primary)' }}
              animationDuration={2000}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload?.length) {
    return (
      <div className="custom-tooltip">
        <p className="tooltip-label">{label}</p>
        <p className="tooltip-value">
          <span>{payload[0].value}</span> Ventas
        </p>
      </div>
    );
  }
  return null;
}

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
  label: PropTypes.string,
};

SalesEvolutionChart.propTypes = {
  data: PropTypes.array,
};

export default SalesEvolutionChart;